<template>
  <div>
    <Proofing-Table :changeOrderCode="changeOrderCode" :disabled="disabled" />
  </div>
</template>

<script>
import ProofingTable from './components/table/index.vue'
export default {
  components: {
    ProofingTable,
  },
  props: {
    changeOrderCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
